import { Box, Button, CircularProgress } from '@mui/material';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { REFETCH_USER_DATA, SET_USER_DATA, SOCKET_CONNNECT } from '../../constants/actionTypes';
import cognitoService from '../../core/service/cognito.service';
import styles from './login.module.scss';
import { PinCodeInput } from '../../core/components';

const mapStateToProps = (state) => {
    return {
        user: state.user.currentUser
    };
};

const mapDispatchToProps = (dispatch) => ({
    onSetUserData: (payload) => dispatch({ type: SET_USER_DATA, payload }),
    onSocketConnect: () => dispatch({ type: SOCKET_CONNNECT }),
    onRefetchUserData: () => dispatch({ type: REFETCH_USER_DATA })
});

const SUCCESS_MESSAGE = 'DONE';

const EnterCode = (props) => {
    const { t } = useTranslation();
    const history = useHistory();
    const [code, setCode] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [disabledButton, setDisabledButton] = useState(true);
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (value) => {
        try {
            setLoading(true);
            const resp = await cognitoService.respondToChallengeSMS(value);
            if (resp) {
                const currentUser = await cognitoService.getUserData();
                setErrorMessage('');
                codeSuccess();
                props.onSocketConnect();
                props.onSetUserData(currentUser);
                props.onRefetchUserData();
                setLoading(false);
                if (currentUser?.groups && currentUser?.groups.includes('Admin')) {
                    return;
                } else {
                    history.push('/my-library');
                }
            }
        } catch (e) {
            setDisabledButton(true);
            if (e.code && e.code === 'NotAuthorizedException') {
                props.onSetUserData({ step: false });
                // history.push('/');
            }
            setErrorMessage(e.message);
            setCode('');
            setLoading(false);
        } finally {
            // setLoading(false);
        }
    };

    const codeSuccess = async () => {
        setCode(SUCCESS_MESSAGE);
    };

    const handleChange = (value) => {
        setErrorMessage('');
        setCode(value);
    };

    const handleComplete = (value) => {
        handleSubmit(value);
    };

    return (
        <Box>
            <PinCodeInput
                length={4}
                value={code}
                error={errorMessage}
                label={t('CheckInbox')}
                onChange={handleChange}
                disabled={loading}
                onComplete={handleComplete}
            />
            {loading ? (
                <Box className={styles.flexProgress}>
                    <CircularProgress size={60} />
                </Box>
            ) : (
                <Button
                    fullWidth
                    disabled={disabledButton}
                    onClick={() => handleSubmit(code)}
                    className={styles.getCodeButton}>
                    {props?.isLogin ? t('ConfirmLogin') : t('ConfirmSignUp')}
                </Button>
            )}
        </Box>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(EnterCode);
